import Handlebars from "../handlebars/handlebars";
import CartRowController from "./CartRowController";
import confirmRemoveFromSavedTitleHtml from "../confirmAction/confirmRemoveFromSavedTitle.hbs"
class SavedRowController extends CartRowController {
    constructor (...args) {
        super(...args);
    }

    handleConfirmItemRemoval () {
        super.handleConfirmItemRemoval(confirmRemoveFromSavedTitleHtml(), (response) => {
            this.triggerProjectUpdatedEvent(response);
        });
    }

    handleAddFilesDialog () {
        super.handleAddFilesDialog(Collaterate.Project.getSaved)
    }
}
export default SavedRowController;